export default "/images/4753131eb508d8112e1544ce1705c3a2.avif";